import { render, staticRenderFns } from "./AppIroColorPicker.vue?vue&type=template&id=74bb862d&"
import script from "./AppIroColorPicker.vue?vue&type=script&lang=ts&"
export * from "./AppIroColorPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports